import { VROverlay } from './overlays.js';
import { CAUI } from 'ca-ui';

export class VRProp extends VROverlay {
  constructor (vr, scene, options) {
    super(vr, scene, options);
    if (this.options.scale) {
      this.setScale(this.options.scale);
    }
  }

  setAsset (asset) {
    this.asset = asset;
    this.setPropId(asset.id);
    this.setScale(this.options.scale);
    if (asset.fixedDistance) {
      this.setDistance(20);
    }
  }

  setPropId (propId) {
    const oldPropId = this.options.propId;
    this.options.propId = propId;
    this.div.removeClass(`ca-vr_overlay_${this.options.type}_${oldPropId}`);
    this.div.addClass('ca-vr_overlay_' + this.options.type + '_' + propId);
  }

  getPropId () {
    return this.options.propId;
  }

  onToggleDayNight () {
    this.setPropId(this.getPropId());
  }

  updateTransform (spawnDistance) {
    super.updateTransform(spawnDistance);
  }

  setScale (scale) {
    if (this.type === undefined) {
      return;
    }
    this.options.scale = scale || 100;
    if (scale && this.type !== 'display_board') {
      const height = CAUI.scale(scale, 0, 100, 400, 800);
      const offset = 800 - height;

      this.img.height(height);
      this.assetContainer.css('margin-top', offset);
    } else if (this.asset !== undefined) {
      if (this.asset.id === 'maptable') {
        this.assetContainer.css('margin-top', '200px');
        this.assetContainer.css('transform', 'translate(-50%, 0)');
        this.assetContainer.css('left', '50%');
        this.img.height(300);
      } else if (this.asset.id === 'ipadstand') {
        this.assetContainer.css('margin-top', '150px');
        this.img.height(650);
      } else {
        this.img.height(800);
        this.assetContainer.css('margin-top', 0);
      }
    }
  }
}
